import { partnerEnabledForExpertUniversity, useExpertUniversityConfiguration } from "@expert/expert-university";
import { Badge, Flex } from "@mantine/core";

import { AsurionWorkspaceLogo } from "@/common-ui";
import { env } from "@/config";
import { useAgentStore, useSessionId } from "@/sdk";

import { HeaderControls } from "./HeaderControls";
import { SessionIdCopyButton } from "./SessionIdCopyButton";
import classes from "./WorkspaceHeader.module.css";
export function WorkspaceHeader() {
    const sessionId = useSessionId();
    const currentActivity = useAgentStore((state) => state.activity);
    const trainingBadge = "Training Mode";
    const { trainingPartner } = useExpertUniversityConfiguration();
    const isExpertUniversityEnabled =
        partnerEnabledForExpertUniversity(trainingPartner, env.channel) &&
        (currentActivity === "Training" || currentActivity === "Residency");
    return (
        <Flex p="xxs" align="center" className={classes.headerContainer}>
            <Flex>
                <Flex className={classes.logo}>
                    <AsurionWorkspaceLogo />
                </Flex>
                {isExpertUniversityEnabled && (
                    <Badge fz="xs" ml="sm" mt="0.3rem" className={classes.trainingHeaderContainer}>
                        {trainingBadge}
                    </Badge>
                )}
                {sessionId && <SessionIdCopyButton key={sessionId} sessionId={sessionId} />}
            </Flex>
            <HeaderControls />
        </Flex>
    );
}
